import React from 'react';
import '../styles/houseLoader.css';

/**
 * The house outline every loading state in the app draws — the full-screen
 * LoadingScreen, the "Designing..." overlay over the 3D viewer, and account
 * setup.
 *
 * One component because the animation depends on the path: the stroke dash
 * length in `houseLoader.css` is this outline's exact length, and the two
 * drifting apart is what made the glyph blink out mid-cycle.
 *
 * Decorative — callers own the loading message and its `role="status"`.
 */
const HOUSE_OUTLINE =
  'M25 5 L5 20 L5 40 L20 40 L20 25 L30 25 L30 40 L45 40 L45 20 Z';

const HouseGlyph = ({ className, stroke = 'currentColor', style }) => (
  <svg
    className={className ? `house-loader ${className}` : 'house-loader'}
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    aria-hidden="true"
    focusable="false"
  >
    <path
      className="house-path"
      d={HOUSE_OUTLINE}
      fill="none"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HouseGlyph;
